import { normalize } from 'normalizr'
import { pathOr } from 'ramda'
import { arrayOfRates } from '../../hwRateSchema'

export default rates => {
    const ratesData = pathOr([], ['_embedded', 'hwRates'], rates)
    return { ...normalize(ratesData, arrayOfRates) }
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/hostelWorldParsers/hwRates.js